import { VIDEO_SERVER_BASE_URL } from "../config/videoServer";
import { getAccessVisitorId, type AccessIdentity } from "./accessTracking";

export type SearchKeywordHistoryItem = {
  keyword: string;
  count: number;
  lastSearchedAt: string;
};

export type SearchKeywordHistory = {
  user: SearchKeywordHistoryItem[];
  public: SearchKeywordHistoryItem[];
  historyDays: number;
};

const normalizeItems = (value: unknown): SearchKeywordHistoryItem[] =>
  Array.isArray(value)
    ? value.flatMap((item) => {
        if (!item || typeof item !== "object") return [];
        const entry = item as Record<string, unknown>;
        const keyword = typeof entry.keyword === "string" ? entry.keyword.trim() : "";
        if (!keyword) return [];
        return [{
          keyword,
          count: typeof entry.count === "number" ? Math.max(0, entry.count) : 0,
          lastSearchedAt: typeof entry.lastSearchedAt === "string" ? entry.lastSearchedAt : "",
        }];
      })
    : [];

export async function fetchSearchKeywordHistory(
  identity: AccessIdentity,
  limit = 20,
): Promise<SearchKeywordHistory> {
  const params = new URLSearchParams({
    visitorId: getAccessVisitorId(),
    userId: identity?.uid || "",
    limit: String(limit),
  });
  const response = await fetch(`${VIDEO_SERVER_BASE_URL}/api/search-keywords?${params}`, {
    cache: "no-store",
    credentials: "include",
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.error || `Search history responded ${response.status}`);
  return {
    user: normalizeItems(body.user),
    public: normalizeItems(body.public),
    historyDays: typeof body.historyDays === "number" ? body.historyDays : 90,
  };
}
